import { Link } from "react-router-dom"
import { SVGcircleCards, SVGcircleGift, SVGcircleHeart } from "./SVG"
import { updateIframeScrollTo } from "../helper"

const Sogehts = () => {
	const gridClasses = "grid grid-cols-[64px_auto] md:grid-cols-1  gap-6 items-center sm:justify-center py-4 "
	const copyClasses = "font-Museo text-base font-semibold leading-normal"

	return (
		<div className="md:py-12">
			<h2 className="h2">So geht's</h2>
			<div className="grid grid-cols-1 gap-6 md:grid-cols-3 text-center mx-auto max-w-6xl px-4">
				<div>
					<div className={gridClasses}>
						<div>
							<SVGcircleHeart />
						</div>
						<div>
							<h2 className=" text-left h2 md:h3 md:min-h-[80px]">1. Gewinne entdecken</h2>
						</div>
					</div>
					<p className={copyClasses}>An jedem Wochentag gibt es etwas Anderes zu gewinnen.</p>
					<div
						onClick={() => {
							const doc: any = document
							let gewinnesection = doc.getElementById("gewinne")
							if (gewinnesection) {
								const firstErrorField: any = gewinnesection
								const offsetTop = window.pageYOffset + firstErrorField.getBoundingClientRect().top - 200

								updateIframeScrollTo(offsetTop)
								window.scrollTo({
									top: offsetTop,
									left: 0,
									behavior: "smooth",
								})
							}
						}}
					>
						<button className="btn mt-6 sm:text-[25px] sm:px-4 sm:py-1">alle gewinne entdecken</button>
					</div>
				</div>
				<div>
					<div className={gridClasses}>
						<div className="col-span">
							<SVGcircleCards />
						</div>
						<div>
							<h2 className=" text-left h2 md:h3 md:min-h-[80px]">2. Zwei Aktionsfelder auf dem Spielfeld aufdecken</h2>
						</div>
					</div>
					<p className={copyClasses}>Nachdem du das Captcha beantwortet hast, öffnet sich ein Spielfeld. Indem du zwei Karten anklickst, erfährst du, ob du gewonnen hast.</p>
				</div>
				<div>
					<div className={gridClasses}>
						<div className="col-span">
							<SVGcircleGift />
						</div>
						<div>
							<h2 className=" text-left h2 md:h3 md:min-h-[80px]">3. Der Zufall entscheidet</h2>
						</div>
					</div>
					<p className={copyClasses}>
						Du erfährst sofort, ob und was du gewonnen hast. Zeigen die aufgedeckten Aktionsfelder dasselbe Bild, wirst du auf eine Seite weitergeleitet, auf der du erfährst, was
						du gewonnen hast und wie du deinen Gewinn erhältst.
					</p>
				</div>
			</div>
			<div className="text-white py-6 lg:py-12 text-center">
				<ul className="md:inline-block">
					<li className="sm:inline-block mx-4">Teilnahme ab 18 Jahren und nur innerhalb Deutschlands möglich.</li>
					<li className="sm:inline-block mx-4">
						<Link
							to="/teilnahmebedingungen"
							className="underline"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "sogehts", link: "teilnahmebedingungen" })
								} catch (e) {}
							}}
						>
							Teilnahmebedingungen
						</Link>
					</li>
					<li className="sm:inline-block mx-4">
						<Link
							to="/datenschutz"
							className="underline"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "sogehts", link: "datenschutz" })
								} catch (e) {}
							}}
						>
							Datenschutzbedingungen
						</Link>
					</li>
					<li className="sm:inline-block mx-4">
						<Link
							to="/faq"
							className="underline"
							onClick={() => {
								try {
									// eslint-disable-next-line
									let dataLayer = window["dataLayer"] || []
									dataLayer.push({ event: "sogehts", link: "faq" })
								} catch (e) {}
							}}
						>
							FAQ
						</Link>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default Sogehts
